(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._root_yhsjp_1{gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250) var(--dixa-size-spacer-300)}._content_yhsjp_6{align-items:center;gap:var(--dixa-size-spacer-300);display:flex}._colorIndicator_yhsjp_12{border-radius:50%;flex-shrink:0;width:8px;height:8px}._text_yhsjp_19{min-width:0}._description_yhsjp_23{white-space:nowrap;margin-top:var(--dixa-size-spacer-100)}._root_1bv8d_54._padded_1bv8d_54{padding:var(--dixa-size-spacer-300)}._root_1bv8d_54._scrollable_1bv8d_57{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:286px}._grid_ss25d_1{gap:var(--dixa-size-spacer-200);padding-top:var(--dixa-size-spacer-250);grid-template-columns:1fr 1fr;display:grid}._link_ss25d_8{color:var(--dixa-typography-color-primary);cursor:pointer;text-decoration-line:none;transition:color .15s ease-in-out}._link_ss25d_8:hover,._link_ss25d_8:focus{color:var(--dixa-typography-color-link);text-decoration-line:none}._popoverContent_4dypo_54{background-color:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);z-index:10550;outline:none}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Box as e, Button as t, Collapsible as n, Column as r, Columns as i, EmptyState as a, FlexBox as o, Icon as s, IconButton as c, InputText as l, SelectionList as u, Spinner as d, Text as f, TextWithHighlight as p, getSelectionListContext as m } from "@dixa/lib-shared-habla";
import * as h from "@radix-ui/react-popover";
import { forwardRef as g, memo as _, useCallback as v, useContext as y, useEffect as b, useMemo as ee, useRef as x, useState as S } from "react";
import { useDebounce as te } from "react-use";
import { Waypoint as ne } from "react-waypoint";
import { jsx as C, jsxs as w } from "react/jsx-runtime";
import T from "classnames";
// src/utils/filter/filterField.ts
var E = {
	conversations: {
		numeric_id: {
			type: "string",
			label: "ID",
			description: "The id of the conversation.",
			icon: "code",
			enrichable: !1
		},
		status: {
			type: "string",
			label: "Status",
			description: "Whether the conversation is open, closed or in follow up.",
			icon: "lock",
			enrichable: !1
		},
		initial_channel: {
			type: "string",
			label: "Channel",
			description: "The channel the conversation originated from.",
			icon: "channels",
			enrichable: !1
		},
		initial_direction: {
			type: "string",
			label: "Direction",
			description: "Whether this is an inbound or outbound conversation.",
			icon: "exchange",
			enrichable: !1
		},
		queue_id: {
			type: "string",
			label: "Queue",
			description: "The current queue of the conversation.",
			icon: "users",
			enrichable: !0
		},
		agent_id: {
			type: "string",
			label: "Agent",
			description: "The agent currently assigned to the conversation.",
			icon: "headset",
			enrichable: !0
		},
		requested_by: {
			type: "string",
			label: "Contact",
			description: "The customer contact of the conversation.",
			icon: "id-card",
			enrichable: !0
		},
		tags: {
			type: "array",
			label: "Tag",
			description: "The tags that are currently applied to the conversation.",
			icon: "tag",
			enrichable: !0
		},
		duration: {
			type: "duration",
			label: "Duration",
			description: "The period from when the conversation was created until it was closed the last time, or time of search if the conversation is open.",
			icon: "clock",
			enrichable: !1
		},
		note_message: {
			type: "text",
			label: "Internal note",
			description: "The content of the internal note in the conversation.",
			icon: "sticky-note",
			enrichable: !1
		},
		note_author_id: {
			type: "string",
			label: "Internal note author",
			description: "The agent who wrote the internal note in the conversation.",
			icon: "headset",
			enrichable: !0
		},
		message_author_id: {
			type: "string",
			label: "Message author",
			description: "The agent who wrote the message in the conversation.",
			icon: "headset",
			enrichable: !0
		},
		abandoned_at: {
			type: "date",
			label: "Abandoned date",
			description: "The date when the conversation was abandoned.",
			icon: "calendar-times",
			enrichable: !1
		},
		assigned_at: {
			type: "date",
			label: "Assigned date",
			description: "The latest time the conversation was assigned to an agent.",
			icon: "calendar",
			enrichable: !1
		},
		closed_at: {
			type: "date",
			label: "Closed date",
			description: "The latest time the conversation was closed.",
			icon: "calendar-times",
			enrichable: !1
		},
		created_at: {
			type: "date",
			label: "Creation date",
			description: "The date when the conversation was created.",
			icon: "calendar-plus",
			enrichable: !1
		},
		last_message_created_at: {
			type: "date",
			label: "Last message",
			description: "The date when the last message was added to the conversation.",
			icon: "calendar-plus",
			enrichable: !1
		},
		updated_at: {
			type: "date",
			label: "Last activity",
			description: "The date when the last activity occurred on the conversation. Conversation activity is defined as one of the following events: internal note added, new message added, tag added, transferred or assigned to a queue or an agent.",
			icon: "calendar",
			enrichable: !1
		},
		note_created_at: {
			type: "date",
			label: "Internal note created date",
			description: "The date when the internal note was created.",
			icon: "calendar-plus",
			enrichable: !1
		},
		conversation_custom_attribute: {
			type: "custom_attribute",
			label: "Conversation custom attribute",
			description: "A custom attribute of the conversation.",
			icon: "input",
			enrichable: !1
		},
		link_type: {
			type: "string",
			label: "Linked type",
			description: "The type of the conversation link.",
			icon: "link",
			enrichable: !1
		},
		linked_to: {
			type: "string",
			label: "Linked to",
			description: "The conversation this is linked to.",
			icon: "link",
			enrichable: !0
		},
		is_abandoned: {
			type: "boolean",
			label: "Abandoned",
			description: "Whether the conversation was abandoned or not.",
			icon: "phone-hang",
			enrichable: !1
		}
	},
	companies: {
		id: {
			type: "string",
			label: "ID"
		},
		created_at: {
			type: "date",
			label: "Creation date"
		}
	},
	queues: {
		id: {
			type: "string",
			label: "ID"
		},
		name: {
			type: "text",
			label: "Name"
		},
		is_archived: {
			type: "boolean",
			label: "Archived"
		},
		is_default: {
			type: "boolean",
			label: "Default"
		},
		is_restricted: {
			type: "boolean",
			label: "Restricted"
		},
		agents: {
			type: "array",
			label: "Agents"
		},
		teams: {
			type: "array",
			label: "Teams"
		}
	},
	tags: {
		id: {
			type: "string",
			label: "ID"
		},
		type: {
			type: "string",
			label: "Type"
		},
		is_deactivated: {
			type: "boolean",
			label: "Deactivated"
		},
		name: {
			type: "text",
			label: "Name"
		}
	},
	teams: {
		id: {
			type: "string",
			label: "ID"
		},
		name: {
			type: "text",
			label: "Name"
		},
		is_deactivated: {
			type: "boolean",
			label: "Deactivated"
		},
		agents: {
			type: "array",
			label: "Agents"
		},
		queues: {
			type: "array",
			label: "Queues"
		},
		created_at: {
			type: "date",
			label: "Creation date"
		},
		updated_at: {
			type: "date",
			label: "Last updated"
		}
	},
	users: {
		id: {
			type: "string",
			label: "ID"
		},
		company_id: {
			type: "string",
			label: "Company"
		},
		email: {
			type: "string",
			label: "Email"
		},
		phone_number: {
			type: "string",
			label: "Phone number"
		},
		type: {
			type: "string",
			label: "Type"
		},
		user_type: {
			type: "string",
			label: "Category"
		},
		has_acw: {
			type: "boolean",
			label: "Wrap-up time"
		},
		is_assigned: {
			type: "boolean",
			label: "Assigned"
		},
		is_online: {
			type: "boolean",
			label: "Online"
		},
		is_working: {
			type: "boolean",
			label: "Working"
		},
		merged_into: {
			type: "array",
			label: "Merged into"
		},
		merged_users: {
			type: "array",
			label: "Merged users"
		},
		queues: {
			type: "array",
			label: "Queues"
		},
		roles: {
			type: "array",
			label: "Roles"
		},
		teams: {
			type: "array",
			label: "Teams"
		},
		name: {
			type: "text",
			label: "Name"
		},
		created_at: {
			type: "date",
			label: "Creation date"
		},
		contact_custom_attribute: {
			type: "custom_attribute",
			label: "Contact custom attribute"
		}
	},
	channels: {}
}, D = {
	is_one: "is one of",
	is_not_one: "is not one of",
	includes_one: "includes one of",
	excludes_one: "excludes one of",
	includes_all: "includes all of",
	excludes_all: "excludes all of",
	is_empty: "is empty",
	is_not_empty: "is not empty",
	between: "between",
	since: "since",
	until: "until",
	gte: "longer than or equal to",
	lte: "shorter than or equal to",
	contains: "contains",
	not_contains: "does not contain",
	equals: "equals",
	not_equals: "does not equal"
}, O = {
	string: ["is_one", "is_not_one"],
	array: [
		"includes_one",
		"excludes_one",
		"includes_all",
		"excludes_all"
	],
	existence: ["is_empty", "is_not_empty"],
	number: [
		"between",
		"gte",
		"lte"
	],
	text: ["contains", "not_contains"],
	date: [
		"between",
		"since",
		"until"
	],
	boolean: ["equals", "not_equals"]
}, k = {
	conversations: {
		numeric_id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		status: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		initial_channel: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		initial_direction: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		requested_by: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		message_author_id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		note_author_id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		agent_id: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		queue_id: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		link_type: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		linked_to: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		tags: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		note_message: {
			defaultOperator: "contains",
			operators: [...O.string, ...O.text]
		},
		is_abandoned: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		duration: {
			defaultOperator: "between",
			operators: [...O.number]
		},
		conversation_custom_attribute: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		abandoned_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		assigned_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		closed_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		last_message_created_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		note_created_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		updated_at: {
			defaultOperator: "between",
			operators: [...O.date]
		}
	},
	companies: {
		id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...O.date]
		}
	},
	queues: {
		id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		name: {
			defaultOperator: "contains",
			operators: [...O.string, ...O.text]
		},
		is_archived: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		is_default: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		is_restricted: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		agents: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		teams: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		}
	},
	tags: {
		id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		type: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		is_deactivated: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		name: {
			defaultOperator: "contains",
			operators: [...O.string, ...O.text]
		}
	},
	teams: {
		id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		name: {
			defaultOperator: "contains",
			operators: [...O.string, ...O.text]
		},
		is_deactivated: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		agents: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		queues: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		updated_at: {
			defaultOperator: "between",
			operators: [...O.date]
		}
	},
	users: {
		id: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		company_id: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		email: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		phone_number: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		},
		type: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		user_type: {
			defaultOperator: "is_one",
			operators: [...O.string]
		},
		has_acw: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		is_assigned: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		is_online: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		is_working: {
			defaultOperator: "equals",
			operators: [...O.boolean]
		},
		merged_into: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		merged_users: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		queues: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		roles: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		teams: {
			defaultOperator: "includes_one",
			operators: [...O.array, ...O.existence]
		},
		name: {
			defaultOperator: "contains",
			operators: [...O.string, ...O.text]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...O.date]
		},
		contact_custom_attribute: {
			defaultOperator: "is_one",
			operators: [...O.string, ...O.existence]
		}
	},
	channels: {}
};
// src/utils/filter/filterTypeGuards.ts
function A(e, t) {
	return Object.values(E).some((n) => n[e]?.type === t);
}
function j(e) {
	return "field" in e;
}
function M(e) {
	let t = e;
	return "strategy" in t && "filters" in t;
}
function N(e) {
	return O.existence.includes(e);
}
function P(e) {
	let t = e.field;
	return A(t, "date");
}
function F(e) {
	return A(e, "date");
}
function I(e) {
	let t = e.field;
	return A(t, "custom_attribute");
}
function L(e) {
	return A(e, "custom_attribute");
}
// src/utils/filter/convertFilters.ts
var R = {
	FIELD: "~",
	VALUES: ",",
	CONDITIONS: ";",
	CUSTOM_ATTRIBUTE_FIELD: ":",
	TIMEZONE: "@"
}, z = RegExp(`^(?:conversation|contact)_custom_attribute\\${R.CUSTOM_ATTRIBUTE_FIELD}.*$`), B = /\(([^)]+)\)/g;
function V(e) {
	if (!e?.filters.length) return "";
	try {
		let t = e.filters.filter(j).reduce((e, t) => {
			let { operator: n, values: r } = t;
			if (!r.length && !N(n)) return e;
			let i = r.length ? r.map(({ value: e }) => Array.isArray(e) ? `(${e.join(R.VALUES)})` : e).join(R.VALUES) : void 0, a = I(t) ? [t.field, t.attributeId].join(R.CUSTOM_ATTRIBUTE_FIELD) : t.field, o = P(t) && t.meta?.timezone ? t.meta.timezone : void 0;
			o && (i += `${R.TIMEZONE}${o}`);
			let s = [
				a,
				n,
				i
			].filter(Boolean).join(R.FIELD);
			return e.push(s), e;
		}, []);
		return t.length && t.unshift(`strategy${R.FIELD}${e.strategy}`), t.join(R.CONDITIONS);
	} catch {
		return "";
	}
}
function H(e) {
	let t = {
		strategy: "all",
		filters: []
	};
	if (!e) return t;
	try {
		let [n, ...r] = e.split(R.CONDITIONS), i = n.split(R.FIELD)[1];
		return ["all", "any"].includes(i) && (t.strategy = i), r.reduce((e, t) => {
			let [n, r, i] = t.split(R.FIELD);
			if (z.test(n)) {
				let [t, a] = n.split(R.CUSTOM_ATTRIBUTE_FIELD), o = [];
				if (i) {
					if (B.test(i)) {
						let e = i.match(B);
						e?.length && o.push(...e.map((e) => ({
							label: "",
							value: e.slice(1, -1).split(R.VALUES)
						})));
					} else o.push(...i.split(R.VALUES).map((e) => ({
						label: e,
						value: e
					})));
				}
				e.filters.push({
					field: t,
					operator: r,
					values: o,
					attributeId: a
				});
			} else {
				let t = i, a;
				if (t && F(n)) {
					let e = t.lastIndexOf(R.TIMEZONE);
					e !== -1 && (a = { timezone: t.slice(e + 1) }, t = t.slice(0, e));
				}
				let o = t ? t.split(R.VALUES).map((e) => ({
					label: "",
					value: e
				})) : [];
				e.filters.push({
					field: n,
					operator: r,
					values: o,
					...a && { meta: a }
				});
			}
			return e;
		}, t);
	} catch {
		return t;
	}
}
// src/utils/filter/filterStrategy.ts
var U = {
	all: {
		label: "ALL",
		description: "If all of the criteria are met"
	},
	any: {
		label: "ONE OR MORE",
		description: "If one or more of the criteria are met"
	}
}, W = () => /* @__PURE__ */ C(e, {
	as: "li",
	padding: "250 300",
	children: /* @__PURE__ */ C(a, {
		title: "No items found",
		description: "Try changing your search criteria."
	})
}), G = {
	root: "_root_yhsjp_1",
	content: "_content_yhsjp_6",
	colorIndicator: "_colorIndicator_yhsjp_12",
	text: "_text_yhsjp_19",
	description: "_description_yhsjp_23"
}, K = _(g(({ className: e, contentClassName: t, children: n, value: r, label: i, description: a, icon: o, highlight: c, textProps: l, ...d }, h) => {
	let { list: { isDisabled: g }, item: { onSelect: _ } } = y(m()), b = v((e) => {
		!d.isDisabled && !g && _({
			value: r,
			meta: {
				target: e?.target,
				event: e || void 0
			}
		});
	}, [
		g,
		_,
		d.isDisabled,
		r
	]);
	return /* @__PURE__ */ w(u.Item, {
		ref: h,
		className: T(G.root, e),
		contentClassName: T(G.content, t),
		...d,
		value: r,
		onClick: b,
		children: [
			o && typeof o == "string" && /* @__PURE__ */ C(s, {
				name: o,
				color: "secondary"
			}),
			o && typeof o != "string" && o,
			/* @__PURE__ */ w("div", {
				className: G.text,
				children: [/* @__PURE__ */ C(f.Paragraph, {
					...l,
					children: /* @__PURE__ */ C(p, {
						text: i,
						highlight: c
					})
				}), a && /* @__PURE__ */ C(f.Paragraph, {
					className: G.description,
					variant: "4",
					subdued: !0,
					children: /* @__PURE__ */ C(p, {
						text: a,
						highlight: c
					})
				})]
			}),
			n
		]
	});
})), q = () => /* @__PURE__ */ C(o, {
	as: "li",
	padding: "250 300",
	alignItems: "center",
	justifyContent: "center",
	children: /* @__PURE__ */ C(d, { size: 20 })
}), J = {
	root: "_root_1bv8d_54",
	padded: "_padded_1bv8d_54",
	scrollable: "_scrollable_1bv8d_57"
}, Y = g(function({ children: e, noPadding: t = !1, ...n }, i) {
	return /* @__PURE__ */ C(r.Row, {
		ref: i,
		className: T(J.root, {
			[J.padded]: !t,
			[J.scrollable]: n.scrollable
		}),
		noHorizontalPadding: !0,
		noVerticalPadding: !0,
		noMinHeight: !0,
		...n,
		children: e
	});
}), X = ({ children: e }) => /* @__PURE__ */ C(i, { children: /* @__PURE__ */ C(r, {
	size: "300px",
	children: e
}) });
X.Item = K, X.Row = Y, X.Empty = W, X.Loading = q;
var Z = {
	grid: "_grid_ss25d_1",
	link: "_link_ss25d_8"
}, Q = _(({ operators: e, defaultOperator: r, selectedOperator: i, isMissingSelectedValues: a = !0, isDropdownOpen: c = !1, isDefaultOpen: l = !1, onChangeOperator: u, onClear: d }) => {
	let [p, m] = S(l);
	b(() => {
		l || m(c && i !== r);
	}, [l, c]);
	let h = v((e) => {
		e !== i && u(e);
	}, [u, i]), g = d && (!a || i && i !== r);
	return /* @__PURE__ */ C(n, {
		isOpen: p,
		header: /* @__PURE__ */ w(o, {
			alignItems: "center",
			justifyContent: "space-between",
			height: "32px",
			children: [/* @__PURE__ */ C(f.ExternalLink, {
				className: Z.link,
				as: "div",
				onClick: () => m(!p),
				children: /* @__PURE__ */ w(o, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ C(s, { name: p ? "angle-down" : "angle-right" }), "Advanced options"]
				})
			}), g && /* @__PURE__ */ C(t, {
				variant: "secondary",
				onClick: d,
				children: "Clear"
			})]
		}),
		children: /* @__PURE__ */ C("div", {
			className: Z.grid,
			children: e.map((e) => /* @__PURE__ */ C(t, {
				variant: "secondary",
				size: "normal",
				active: e === i,
				onClick: () => h(e),
				children: D[e] ?? String(e)
			}, e))
		})
	});
}), re = { popoverContent: "_popoverContent_4dypo_54" }, $ = _(({ items: e, operators: n, defaultOperator: r, showSearch: i = !0, placeholder: a = "Search...", isMultiple: d = !0, buttonProps: f, popoverContentProps: p, selectedValues: m, selectedOperator: g, isFetching: _, isSuccess: y, hasNextPage: T, onChange: E, onOpenChange: D, onSearch: O, onLoadMore: k, children: A }) => {
	let j = x(null), M = x(null), [P, F] = S(!1), [I, L] = S(""), [R, z] = S(""), [B, V] = S(g ?? r);
	te(() => z(I), 300, [I]), b(() => {
		V(g ?? r);
	}, [g, r]);
	let H = N(B), U = ee(() => {
		if (!e) return [];
		if (O || !R) return e;
		let t = R.toLowerCase();
		return e.filter((e) => e.label.toLowerCase().includes(t));
	}, [
		e,
		O,
		R
	]), W = v((e) => {
		F(e), D?.(e), e && i && setTimeout(() => j.current?.focus()), e && M.current && (M.current.scrollTop = 0), e || (L(""), z(""));
	}, [D, i]), G = v(({ selectedValues: e }) => {
		E({
			action: e.length ? "upsert" : "remove",
			values: e,
			operator: B
		}), d || F(!1);
	}, [
		E,
		B,
		d
	]), K = v((e) => {
		V(e);
		let t = N(e) ? [] : m ?? [];
		E({
			action: e === r && !t.length ? "remove" : "upsert",
			values: t,
			operator: e
		});
	}, [
		E,
		m,
		r
	]), q = v(() => {
		V(r), E({
			action: "remove",
			values: [],
			operator: r
		});
	}, [r, E]), J = v((e) => {
		L(e.target.value), O?.(e.target.value);
	}, [O]), Y = v(() => {
		L(""), z(""), O?.(""), j.current?.focus();
	}, [O]);
	b(() => {
		M.current && (M.current.scrollTop = 0);
	}, [R]);
	let Z = m && m.length > 0, $ = Z ? m.length : H ? 1 : void 0, ie = !U.length && !_ && (y ?? !O);
	return /* @__PURE__ */ w(h.Root, {
		open: P,
		onOpenChange: W,
		children: [/* @__PURE__ */ C(h.Trigger, {
			asChild: !0,
			children: /* @__PURE__ */ C(t, {
				variant: "tertiary",
				...f,
				label: f?.label ?? $,
				slotEnd: f?.slotEnd ?? /* @__PURE__ */ C(s, { name: P ? "angle-up" : "angle-down" }),
				children: A
			})
		}), /* @__PURE__ */ C(h.Portal, { children: /* @__PURE__ */ C(h.Content, {
			className: re.popoverContent,
			side: "bottom",
			align: "start",
			sideOffset: 8,
			onOpenAutoFocus: (e) => e.preventDefault(),
			...p,
			children: /* @__PURE__ */ w(X, { children: [
				i && /* @__PURE__ */ C(X.Row, {
					borderBottom: !0,
					children: /* @__PURE__ */ C(l, {
						ref: j,
						value: I,
						onChange: J,
						placeholder: a,
						suffix: {
							type: "custom",
							value: /* @__PURE__ */ C(o, {
								alignItems: "center",
								padding: "0 100",
								children: /* @__PURE__ */ C(c, {
									variant: "tertiary",
									icon: I ? "close" : "search",
									onClick: I ? Y : void 0
								})
							}),
							noWrap: !0
						}
					})
				}),
				/* @__PURE__ */ C(X.Row, {
					ref: M,
					noPadding: !0,
					scrollable: !0,
					children: /* @__PURE__ */ w(u, {
						isMultiple: d,
						isActive: P,
						isDisabled: H,
						selectedValues: m ?? [],
						onChange: G,
						equalityFn: (e, t) => e.value === t.value,
						defaultActiveItemIndex: 0,
						children: [
							U.map((e) => /* @__PURE__ */ C(X.Item, {
								value: {
									value: e.value,
									label: e.label
								},
								label: e.label,
								description: e.description,
								icon: e.icon,
								highlight: R
							}, e.value)),
							_ && /* @__PURE__ */ C(X.Loading, {}),
							ie && /* @__PURE__ */ C(X.Empty, {}),
							!_ && T && k && /* @__PURE__ */ C(ne, { onEnter: k })
						]
					})
				}),
				n && /* @__PURE__ */ C(X.Row, {
					borderTop: !0,
					children: /* @__PURE__ */ C(Q, {
						operators: n,
						selectedOperator: B,
						defaultOperator: r,
						isMissingSelectedValues: !Z,
						isDropdownOpen: P,
						onChangeOperator: K,
						onClear: q
					})
				}),
				!n && (Z || B !== r) && /* @__PURE__ */ C(X.Row, {
					borderTop: !0,
					children: /* @__PURE__ */ C(t, {
						variant: "secondary",
						onClick: q,
						children: "Clear"
					})
				})
			] })
		}) })]
	});
});
export { $ as SearchFilter, X as SearchFilterLayout, Q as SearchFilterOptions, V as convertFiltersObjectToString, H as convertFiltersStringToObject, E as filterFieldCatalogue, k as filterOperatorCatalogue, O as filterOperatorGroups, D as filterOperatorLabels, U as filterStrategyCatalogue, I as isCustomAttributeCondition, L as isCustomAttributeField, P as isDateFilterCondition, F as isDateFilterField, N as isExistenceFilterOperator, j as isLeafFilterCondition, M as isNestedFilterGroup };

//# sourceMappingURL=index.js.map